import { useState } from "react";

const SERVER_URL = process.env.REACT_APP_SERVER_BASE_URL;
const AUTH_STATUSES = [401, 403, 404];
const GENERIC_ERROR =
  "Não foi possível processar a lista. Verifique se ela segue um dos formatos aceitos.";

const PRICE_FIELDS = [
  "promotionPrice",
  "normalSellingPrice",
  "varejoPrice",
  "atacadoPrice",
];

// TODO: remove once the backend returns prices with comma (products/list).
const pricesToComma = (products) =>
  Array.isArray(products)
    ? products.map((product) => {
        const converted = { ...product };
        PRICE_FIELDS.forEach((field) => {
          if (typeof converted[field] === "string") {
            converted[field] = converted[field].replace(".", ",");
          }
        });
        return converted;
      })
    : products;

export default function useProductListProcessor() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const processProductList = async (productList, token) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${SERVER_URL}products/list`, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          Authorization: `${token}`,
        },
        body: productList,
      });

      if (!response.ok) {
        setError(
          AUTH_STATUSES.includes(response.status)
            ? "Sessão expirada. Recarregue a página e faça login novamente."
            : GENERIC_ERROR,
        );
        return;
      }

      return pricesToComma(await response.json());
    } catch (err) {
      // fetch rejects with TypeError only on network failure; other errors are bad responses.
      setError(
        err instanceof TypeError
          ? "Sem conexão. Tente novamente."
          : GENERIC_ERROR,
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { processProductList, loading, error };
}
